// must be first
import './polyfills'

import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { TrackingEventType } from '@ftr/foundation'
import { WindowConfig, WindowRef } from '@ftr/window'
import { AppModule } from '~admin/app/app.module'
import { environment } from '~admin/environments/environment'

const LOGGING_URL_CLOUDPLATFORMADMIN_DEVELOP =
  'https://collectors.au.sumologic.com/receiver/v1/http/ZaVnC4dhaV2dIa2htl70HnpEiyWMOiNf9Lv8TBVF3tm7yvEGqCEsOj6vFEjcfVtiSA7r5gaLI0wMAc3-porB-wTRet6lNf9Z0caJMjRMk0Wtj2_bvHqGZw=='
const LOGGING_URL_CLOUDPLATFORMADMIN_PRODUCTION =
  'https://collectors.au.sumologic.com/receiver/v1/http/ZaVnC4dhaV2zNpz4R3qSbbtYU4peGFbOA_Rv4GTub11fQrS-8xwj1M79JdimXjJcG7VhFLACqikFDqKgsqFpQMFcwU4pOuLfTQLplnxt7dkzDAZ3SFNxJw=='

if (environment.production) {
  enableProdMode()
}
/**
 * If we are in a production environment, we need to bootstrap angular config variables are loaded.
 * process.env.CONFIG is set in the webpack config.
 * This script contains things like our logging url etc.
 */

const ref = window as unknown as WindowRef
ref.config = process.env.CONFIG as unknown as WindowConfig

enableTracking()
enableNewRelicMonitoring()
overrideConfigValues({
  LoggingUrl: environment.production
    ? LOGGING_URL_CLOUDPLATFORMADMIN_PRODUCTION
    : LOGGING_URL_CLOUDPLATFORMADMIN_DEVELOP,
})
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err))

function overrideConfigValues(overrideValues: Partial<WindowConfig>): void {
  const windowRef = window as unknown as WindowRef
  const config = windowRef.config || environment.config
  windowRef.config = {
    ...config,
    ...overrideValues,
  }
}
/**
 * Google tag manager tracking script, just done in body, rather than head, due to needing the config
 */
function enableTracking(): void {
  const windowRef = window as unknown as WindowRef
  if (!windowRef.dataLayer) {
    windowRef.dataLayer = [{ 'gtm.start': new Date().getTime(), event: 'gtm.js' as TrackingEventType }]
    const script = document.createElement('script')
    script.async = true
    const config = windowRef.config || environment.config
    script.src = `https://www.googletagmanager.com/gtm.js?id=${config?.TrackingContainerCode || 'GTM-M73SKXB'}`
    document.body.appendChild(script)
  }
}
function enableNewRelicMonitoring(): void {
  const windowRef = window as unknown as WindowRef
  if (windowRef.config?.NewRelicWebAppId) {
    const newrelicScript = document.createElement('script')
    newrelicScript.src = '/newrelic.js'
    document.head.appendChild(newrelicScript)
  }
}
